import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarSparkleOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 4c1.5 2.25 3.75 4.5 6 6-2.25 1.5-4.5 3.75-6 6-1.5-2.25-3.75-4.5-6-6 2.25-1.5 4.5-3.75 6-6m0 2.352A25 25 0 0 1 2.352 10 25 25 0 0 1 6 13.648 25 25 0 0 1 9.647 10 25 25 0 0 1 6 6.352"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.667 0c.833 1.25 2.084 2.5 3.334 3.333-1.25.833-2.5 2.084-3.334 3.334a12.7 12.7 0 0 0-3.333-3.334c1.25-.833 2.5-2.083 3.333-3.333m0 2.264c-.336.373-.696.733-1.07 1.069.374.336.734.696 1.07 1.07.337-.374.696-.734 1.07-1.07a15 15 0 0 1-1.07-1.07"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
HyperstarSparkleOutlinedSize16Glyph.displayName = 'HyperstarSparkleOutlinedSize16Glyph';
